<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/C8ManS/tc-custom/9780795351174.jpg?1725275240875" alt="This image is the cover for the book Sharon Sala Suspense Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sharon Sala Suspense Stories
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Three romantic suspense novels from the #1 <i>New York Times</i>–bestselling author of the Jigsaw Files novels.</b><br/><br/><b>Butterfly</b><br/> A tough-as-nails detective is on the case of a murdered celebrity photographer—and hot for the star witness. But as things heat up and they grow closer to each other, the killer grows closer to them . . .<br/><br/><b>Bloodlines</b><br/> When a child’s skeleton is found hidden in a wall, Olivia Sealy’s past resurfaces. Her former sweetheart is the detective assigned to the case, which reminds her of the kidnapping ordeal she underwent as a child. Plus, there is the matter of the kidnapper the police never apprehended . . .<br/><br/><b>Mimosa Grove</b><br/> A Louisiana woman’s gift of second sight leads her to a missing girl, and the mystery man of her dreams . . .<br/><br/><b>“[Sala] spins an intricate tale of treachery and terror.”—<i>RT Book Reviews </i>on <i>Mimosa Grove</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Sala
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      RosettaBooks, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03173978